import { Button } from '../../../atoms/Button';

interface ExamInfoFooterProps {
  onStartExamClick: () => void;
  label?: string;
  isLoading?: boolean;
}

export default function ExamInfoFooter({
  onStartExamClick,
  label = 'Iniciar simuladão',
  isLoading = false,
}: ExamInfoFooterProps) {
  return (
    <footer
      className='
                    font-noto bottom-0 left-0 flex h-28
                    flex-col items-center justify-center md:h-20 lg:fixed
                    lg:w-full lg:border-t-hairline 
                    lg:border-t-mono-color-lightest lg:bg-color-lightest lg:shadow-level-2'
    >
      <Button
        onClick={onStartExamClick}
        loading={isLoading}
        disabled={isLoading}
      >
        {label}
      </Button>
    </footer>
  );
}
